module.exports = __webpack_public_path__ + "img/5.Beds&pats.32648c34.jpg";